/** @namespace Constants */

/**
 * @constant {string}
 * @memberof Constants
 */
export const GREENHOUSE_GUIDANCE = 'https://hello.datapeople.io/docs/greenhouse';

/**
 * @constant {string}
 * @memberof Constants
 */
export const WORKDAY_GUIDANCE = 'https://hello.datapeople.io/docs/workday-recruiting';

/**
 * @constant {string}
 * @memberof Constants
 */
export const SUCCESSFACTORS_GUIDANCE = 'https://hello.datapeople.io/docs/successfactors-recruiting';

/**
 * @constant {string}
 * @memberof Constants
 */
export const ICIMS_GUIDANCE = 'https://hello.datapeople.io/docs/icims';

/**
 * @constant {string}
 * @memberof Constants
 */
export const GR8PEOPLE_GUIDANCE = 'https://hello.datapeople.io/docs/gr8people';

/**
 * @constant {string}
 * @memberof Constants
 */
export const LEVER_GUIDANCE = 'https://hello.datapeople.io/docs/lever';

/**
 * @constant {string}
 * @memberof Constants
 */
export const SMARTRECRUITERS_GUIDANCE = 'https://hello.datapeople.io/docs/smartrecruiters';
